/* eslint react/no-danger: 'off' */
/* global translations */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import get from 'lodash/get';
import { VerificationImages, VerificationWebcam, VerificationError } from '../../components/verification';
import VerificationStore from '../../stores/VerificationStore';
import { VerificationActionCreators } from '../../actions';

class VerificationContainer extends Component {
  state = {
    capturedImage: VerificationStore.getCapturedImage(),
    webcamOpen: false,
    webcamRoot: false,
    error: VerificationStore.getError(),
    disabled: VerificationStore.getDisabled(),
    needActivate: VerificationStore.getNeedActivate(),
    needImage: VerificationStore.getNeedImage(),
    forceRetake: VerificationStore.getForceRetake(),
    adminComment: VerificationStore.getAdminComment(),
    isSimulated: VerificationStore.getIsSimulated(),
  };

  componentDidMount() {
    VerificationStore.addChangeListener(this.onChange);
    this.inputFile = React.createRef();
  }

  componentWillUnmount() {
    VerificationStore.removeChangeListener(this.onChange);
  }

  onChange = () => {
    this.setState({
      capturedImage: VerificationStore.getCapturedImage(),
      error: VerificationStore.getError(),
      disabled: VerificationStore.getDisabled(),
      needActivate: VerificationStore.getNeedActivate(),
      adminComment: VerificationStore.getAdminComment(),
      isSimulated: VerificationStore.getIsSimulated(),
      needImage: VerificationStore.getNeedImage(),
      forceRetake: VerificationStore.getForceRetake(),
    });
  };

  uploadImage = () => {
    this.inputFile.current.click();
  };

  setWebcamOpen = (webcamOpen) => {
    // this.setState({ webcamOpen });

    // To do it like this, is necessary because of iOS
    const webcamRoot = document.getElementById('verification-webcam');
    if (!webcamRoot) {
      this.setState({
        webcamOpen,
        webcamRoot: false,
      });
      return;
    }

    if (webcamOpen) {
      ReactDOM.render(
        <div className="verification-webcamContainer">
          <VerificationWebcam
            captureImage={this.setCapturedImage}
            closeWebcam={() => this.setWebcamOpen(false)}
            example={VerificationStore.getExampleImage()}
          />
        </div>,
        webcamRoot,
      );
    } else {
      ReactDOM.unmountComponentAtNode(webcamRoot);
    }

    this.setState({
      webcamOpen,
      webcamRoot: true,
    });
    //
  };

  handleFileInputChange = async (e) => {
    const file = e.target.files[0];
    const base64 = await this.convertBase64(file);

    this.setCapturedImage(base64);
  };

  convertBase64 = (file) => new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });

  setCapturedImage = (capturedImage) => {
    VerificationStore.setCapturedImage(capturedImage);
    VerificationStore.setError(null);
    VerificationStore.setForceRetake(false);
    VerificationStore.emitChange();

    this.setWebcamOpen(false);
  };

  onSubmit = () => {
    VerificationStore.setLoading(true);
    VerificationStore.setError(null);
    VerificationStore.emitChange();

    VerificationActionCreators.submitCapturedImage();
  };

  render() {
    const {
      capturedImage,
      webcamOpen,
      webcamRoot,
      error,
      disabled,
      needActivate,
      needImage,
      forceRetake,
      adminComment,
      isSimulated,
    } = this.state;

    //
    const instructions = () => {
      if (disabled || needActivate || needImage) {
        return (null);
      }

      return (
        <div>
          <div className="twb">{get(translations, 'txt: Lai apstiprinātu savu profilu, atdarini šo pozu un nofotografē to', '')}</div>
          <VerificationImages
            example={VerificationStore.getExampleImage()}
            image={capturedImage}
            error={forceRetake}
          />
          <div className="tsi">{get(translations, 'txt: Mēs šo bildi nekur nepublicēsim', '')}</div>
          <div
            className="twb mts mbm"
            dangerouslySetInnerHTML={{
              __html: get(translations, 'txt: Lai verifikācija noritētu veiksmīgi attēlotajai pozai jābūt pēc iespējas precīzi atkārtotai', ''),
            }}
          />
        </div>
      );
    };

    //
    const errorMessage = () => {
      if (disabled) {
        return (
          <VerificationError
            message="txt: Atvaino, mēs nevaram verificēt Tavu profilu"
          />
        );
      }

      if (needActivate) {
        return (
          <VerificationError
            message="txt: Atvaino, mēs nevaram verificēt Tavu profilu, ja neesi apstiprinājis epastu"
            action="activate"
          />
        );
      }

      if (needImage) {
        return (
          <VerificationError
            message="txt: Atvaino, mēs nevaram verificēt Tavu profilu, ja neesi ievietojis profila bildi"
            action="images"
          />
        );
      }

      if (error) {
        return <VerificationError message={error} adminComment={adminComment} />;
      }

      return (null);
    };

    //
    const actions = () => {
      if (disabled || needActivate || needImage) {
        return (null);
      }

      return (
        <div>
          {(capturedImage && !forceRetake) && (
            <button
              type="button"
              className="btn btn--a mbm mrs"
              onClick={this.onSubmit}
            >
              {get(translations, 'txt: Iesniegt', '')}
            </button>
          )}
          { !isSimulated
            ? (
              <button
                type="button"
                className={`mbm btn ${capturedImage ? 'btn--c' : 'btn--a'}`}
                onClick={() => this.setWebcamOpen(true)}
              >
                {get(translations, (capturedImage ? 'txt: Fotografēt vēlreiz' : 'txt: Fotografēt'), '')}
              </button>
            ) : (
              <>
                <button
                  type="button"
                  className={`mbm btn ${capturedImage ? 'btn--c' : 'btn--b'}`}
                  onClick={() => this.uploadImage()}
                >
                  {get(translations, (capturedImage ? 'txt: Augšupielādēt vēlreiz' : 'txt: Augšupielādēt'), '')}
                </button>
                <input type="file" id="file" ref={this.inputFile} style={{ display: 'none' }} onChange={this.handleFileInputChange} />
              </>
            )}
        </div>
      );
    };

    //
    return (
      <div className="bbl pbs">
        {instructions()}
        {errorMessage()}
        {actions()}
        {(webcamOpen && !webcamRoot) && (
          <div className="verification-webcamContainer">
            <VerificationWebcam
              captureImage={this.setCapturedImage}
              closeWebcam={() => this.setWebcamOpen(false)}
              example={VerificationStore.getExampleImage()}
            />
          </div>
        )}
      </div>
    );
  }
}

export default VerificationContainer;
